import gql from 'graphql-tag';

export default gql`
    mutation AddBoxes($input: AddBoxesInput) {
        addBoxes(input: $input) {
            errors
        }
    }
`;
